import InfoOnMultipleLine, { InfoOnMultipleLineProps } from './InfoOnMultipleLine';

export type { InfoOnMultipleLineProps };
export default InfoOnMultipleLine;
